import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {PRIMARY_CUSTOMER_SERVICE} from '../../../../constants/contacts';

// import * as headerActionCreators from '../../../actions/header';
let allActionCreators = Object.assign({});

class NolaFlood2021 extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
	}

  // componentDidMount() {
  //   let link = document.createElement('meta');
  //   link.setAttribute('property', 'og:image');
  //   link.content = 'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/DSC_0893.jpg';
  //   document.getElementsByTagName('head')[0].appendChild(link);
  // }

	internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className='NolaFlood2021'>
			<div className='productHeader'>
        <img className='desktopOnly' src='https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/nola_banner.png' />
        <img className='mobileOnly' src='https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/nola_banner.png' />
      </div>

      <div className='itemArray'>

      	<div className='nolaNotice'>
	      	<div className='nolaNoticeWrapper'>
	      		<div className='nolaTitle'>The New Orleans Collection</div>
	      		<div className='nolaLine'>
	      			<img src='https://ddw2.diamondsdirect.com/img/icons/lines/iconline_thin.svg' />
	      		</div>
	      		<div className='nolaCopy'>Thank you for your interest in donating to the Diamonds Direct Foundation’s Hurricane Ida relief efforts.</div>
	      		<div className='nolaCopy'><span className='nolaEm'>100% of the proceeds</span> from purchases within this collection will support one of the three New Orleans based charitable organizations we’ve selected to help our friends and neighbors during this critical time; <span className='nolaEm'>Cajun Navy Ground Force</span>, <span className='nolaEm'>Second Harvest Foodbank</span>, and <span className='nolaEm'>The Diamonds Direct Employee Relief Fund</span>.</div>
	      		<div className='nolaCopy'>We are grateful for your generosity and support!</div>
	      	</div>
	      </div>
        
        <div 
          className='itemElement'
          onClick={() => {this.internalNav('band/BLDSM08583')}}>
          <div className='itemThumb'>
            <div className='imgOverlay'>
              <div className='overlayTitle'>Straight Bar Diamond Band</div>
            </div>
            <img src={'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/BLDSM08583.png'} />
          </div>
          <div className='labelWrapper'>
            <div className='itemName'>Straight Bar Diamond Band</div>
            <div className='itemPrice'>$390</div>
          </div>
        </div>

        <div 
          className='itemElement'
          onClick={() => {this.internalNav('band/BLDMD26933')}}>
          <div className='itemThumb'>
            <div className='imgOverlay'>
              <div className='overlayTitle'>Narrow "X" Diamond Band</div>
            </div>
            <img src={'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/BLDMD26933.png'} />
          </div>
          <div className='labelWrapper'>
            <div className='itemName'>Narrow "X" Diamond Band</div>
            <div className='itemPrice'>$1,100</div>
          </div>
        </div>

        <div 
          className='itemElement'
          onClick={() => {this.internalNav('band/BLDSM07123')}}>
          <div className='itemThumb'>
            <div className='imgOverlay'>
              <div className='overlayTitle'>Geometric Diamond Wedding Band</div>
            </div>
            <img src={'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/BLDSM07123.png'} />
          </div>
          <div className='labelWrapper'>
            <div className='itemName'>Geometric Diamond Wedding Band</div>
            <div className='itemPrice'>$500</div>
          </div>
        </div>

        <div 
          className='itemElement'
          onClick={() => {this.internalNav('jewelry/EFAND07300')}}>
          <div className='itemThumb'>
            <div className='imgOverlay'>
              <div className='overlayTitle'>Contemporary Dimond Accented Stud Earrings</div>
            </div>
            <img src={'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/EFAND07300.png'} />
          </div>
          <div className='labelWrapper'>
            <div className='itemName'>Contemporary Dimond Accented Stud Earrings</div>
            <div className='itemPrice'>$475</div>
          </div>
        </div>

        <div 
          className='itemElement'
          onClick={() => {this.internalNav('jewelry/EFAND14535')}}>
          <div className='itemThumb'>
            <div className='imgOverlay'>
              <div className='overlayTitle'>Flower Diamond Stud Earrings</div>
            </div>
            <img src={'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/EFAND14535.png'} />
          </div>
          <div className='labelWrapper'>
            <div className='itemName'>Flower Diamond Stud Earrings</div>
            <div className='itemPrice'>$1,050</div>
          </div>
        </div>

        <div 
          className='itemElement'
          onClick={() => {this.internalNav('jewelry/EFAND10724')}}>
          <div className='itemThumb'>
            <div className='imgOverlay'>
              <div className='overlayTitle'>Two-Tone Geometric Drop Earrings</div>
            </div>
            <img src={'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/EFAND10724.png'} />
          </div>
          <div className='labelWrapper'>
            <div className='itemName'>Two-Tone Geometric Drop Earrings</div>
            <div className='itemPrice'>$795</div>
          </div>
        </div>

        <div 
          className='itemElement'
          onClick={() => {this.internalNav('jewelry/NFANC06219')}}>
          <div className='itemThumb'>
            <div className='imgOverlay'>
              <div className='overlayTitle'>Lowercase Initial "M" Pendant</div>
            </div>
            <img src={'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/NFANC06219.png'} />
          </div>
          <div className='labelWrapper'>
            <div className='itemName'>Lowercase Initial "M" Pendant</div>
            <div className='itemPrice'>$450</div>
          </div>
        </div>

        <div 
          className='itemElement'
          onClick={() => {this.internalNav('jewelry/NFANC21445')}}>
          <div className='itemThumb'>
            <div className='imgOverlay'>
              <div className='overlayTitle'>Baguette Diamond Bar Pendant</div>
            </div>
            <img src={'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/NFANC21445.png'} />
          </div>
          <div className='labelWrapper'>
            <div className='itemName'>Baguette Diamond Bar Pendant</div>
            <div className='itemPrice'>$620</div>
          </div>
        </div>

        <div 
          className='itemElement'
          onClick={() => {this.internalNav('jewelry/NFANC23846')}}>
          <div className='itemThumb'>
            <div className='imgOverlay'>
              <div className='overlayTitle'>Diamond Bezel Solitaire Pendant</div>
            </div>
            <img src={'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/NFANC23846.png'} />
          </div>
          <div className='labelWrapper'>
            <div className='itemName'>Diamond Bezel Solitaire Pendant</div>
            <div className='itemPrice'>$375</div>
          </div>
        </div>

        <div 
          className='itemElement'
          onClick={() => {this.internalNav('jewelry/TBMIS03975')}}>
          <div className='itemThumb'>
            <div className='imgOverlay'>
              <div className='overlayTitle'>Diamonds By The Yard Bracelet</div>
            </div>
            <img src={'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/TBMIS03975.png'} />
          </div>
          <div className='labelWrapper'>
            <div className='itemName'>Diamonds By The Yard Bracelet</div>
            <div className='itemPrice'>$330</div>
          </div>
        </div>

        <div 
          className='itemElement'
          onClick={() => {this.internalNav('jewelry/TBMIS02595')}}>
          <div className='itemThumb'>
            <div className='imgOverlay'>
              <div className='overlayTitle'>Five Bar Diamond Bracelet</div>
            </div>
            <img src={'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/TBMIS02595.png'} />
          </div>
          <div className='labelWrapper'>
            <div className='itemName'>Five Bar Diamond Bracelet</div>
            <div className='itemPrice'>$790</div>
          </div>
        </div>

        <div 
          className='itemElement'
          onClick={() => {this.internalNav('jewelry/GBANG00738')}}>
          <div className='itemThumb'>
            <div className='imgOverlay'>
              <div className='overlayTitle'>Classic Diamond Bangle</div>
            </div>
            <img src={'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/GBANG00738.png'} />
          </div>
          <div className='labelWrapper'>
            <div className='itemName'>Classic Diamond Bangle</div>
            <div className='itemPrice'>$1,150</div>
          </div>
        </div>

        <div 
          className='itemElement'
          onClick={() => {this.internalNav('jewelry/CUSTM00017')}}>
          <div className='itemThumb'>
            <div className='imgOverlay'>
              <div className='overlayTitle'>Cash Donation</div>
            </div>
            <img src={'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/blank_thumb2.png'} />
          </div>
          <div className='labelWrapper'>
            <div className='itemName'>Cash Donation</div>
            <div className='itemPrice'>$25</div>
          </div>
        </div>

        <div 
          className='itemElement'
          onClick={() => {this.internalNav('jewelry/CUSTM00018')}}>
          <div className='itemThumb'>
            <div className='imgOverlay'>
              <div className='overlayTitle'>Cash Donation</div>
            </div>
            <img src={'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/blank_thumb2.png'} />
          </div>
          <div className='labelWrapper'>
            <div className='itemName'>Cash Donation</div>
            <div className='itemPrice'>$50</div>
          </div>
        </div>

        <div 
          className='itemElement'
          onClick={() => {this.internalNav('jewelry/CUSTM00019')}}>
          <div className='itemThumb'>
            <div className='imgOverlay'>
              <div className='overlayTitle'>Cash Donation</div>
            </div>
            <img src={'https://ddw2.diamondsdirect.com/img/promopages/nolaflood2021/blank_thumb2.png'} />
          </div>
          <div className='labelWrapper'>
            <div className='itemName'>Cash Donation</div>
            <div className='itemPrice'>$100</div>
          </div>
        </div>

      </div>
		</div>;
	}
}
export default NolaFlood2021;

function mapStateToProps(state) {
  return {

  };
}

export const NolaFlood2021Container = connect(
  mapStateToProps,
  allActionCreators
)(NolaFlood2021);


// WEBPACK FOOTER //
// ./src/components/views/promopages/nolaflood2021/NolaFlood2021.jsx